const History = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                {
    /* Mobile Layout (sm:flex) */
  }
                <div className="mx-auto max-w-7xl lg:hidden">
                    <div className="flex flex-col gap-8">
                        {
    /* Header */
  }
                        <div>
                            <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                                Weitergegebene Weisheit
                            </p>
                            <h2 className="mt-5 font-serif text-2xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-3xl">
                                Geschichte des Ayurveda: Jahrtausende alte Weisheit
                            </h2>
                        </div>

                        {
    /* Image */
  }
                        <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] bg-[#f3eee7] shadow-[0_24px_70px_rgba(16,38,26,0.14)]">
                            <img
    src="/images/ayurveda-massage-treatment.webp"
    alt="Ayurveda-Behandlung"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/55 via-transparent to-transparent" />
                        </div>

                        {
    /* Content */
  }
                        <div className="space-y-8 font-mulish text-base leading-8 text-gray-700">
                            <div>
                                <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c]">
                                    Von der mündlichen Tradition zu den Heiligen Schriften
                                </h3>
                                <p className="mt-3">
                                    Das enorme Wissen des Ayurveda wurde ursprünglich von weisen Gelehrten aus dem alten Indien über Generationen hinweg mündlich weitergegeben. Später wurde es um das 2. Jahrtausend v. Chr. in Sanskrit niedergeschrieben – in den ältesten heiligen Schriften Indiens, den Veden. Diese Texte bilden nicht nur die Grundlage des Ayurveda, sondern auch die Ursprünge der Yoga-Lehren und -Praxis.
                                </p>
                            </div>

                            <div>
                                <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c]">
                                    Die drei wichtigsten medizinischen Hauptwerke
                                </h3>
                                <p className="mt-3">
                                    Die folgenden drei Heiligen Schriften, die zwischen 2500 und 1200 Jahren vor Christus kompiliert wurden, spielen in der Ayurveda-Medizin eine extrem wichtige Rolle.
                                </p>
                                <ul className="mt-4 space-y-2 border-l-2 border-[#F28600] pl-5 font-semibold text-[#24422f]">
                                    <li>Charaka Samhita</li>
                                    <li>Sushruta Samhita</li>
                                    <li>Ashthanga Hridaya Samhita</li>
                                </ul>
                                <p className="mt-4">
                                    Diese Bücher enthalten bemerkenswert detailliertes Wissen über den menschlichen Körper, Krankheitserreger, Hygiene und sogar fortgeschrittene chirurgische Techniken.
                                </p>
                            </div>

                            <div>
                                <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c]">
                                    Was bedeutet wahre „Gesundheit“?
                                </h3>
                                <p className="mt-3">
                                    Vor etwa 2500 Jahren definierte der indische Arzt Sushruta, der als einer der ersten Chirurgen der Welt gilt, den Zustand eines „gesunden Menschen“ im Ayurveda wie folgt.
                                </p>
                                <blockquote className="mt-5 pt-5 font-serif text-xl leading-relaxed text-[#1f4d3c]">
                                    „Ein Mensch ist wirklich gesund, wenn er in sich selbst gefestigt ist, ein Gleichgewicht zwischen Doshas (Lebensenergien), Agni (Verdauungsfeuer), Dhatus (Körpergeweben) und Malas (Ausscheidungen) besitzt und seine körperlichen Funktionen sowie Geist, Seele und Sinne in Zufriedenheit und Harmonie stehen.“
                                    <cite className="mt-4 block font-mulish text-sm not-italic text-gray-600">
                                        —— Sushruta Samhita, Kapitel 15, Vers 38
                                    </cite>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>

                {
    /* Desktop Layout (hidden on sm, visible on lg) */
  }
                <div className="mx-auto hidden max-w-7xl items-start gap-10 lg:grid lg:grid-cols-[1.08fr_0.92fr] lg:gap-16">
                    <div className="order-1">
                        <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                            Weitergegebene Weisheit
                        </p>
                        <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Geschichte des Ayurveda: Jahrtausende alte Weisheit
                        </h2>

                        <div className="mt-8 space-y-8 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                            <div>
                                <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c] sm:text-3xl">
                                    Von der mündlichen Tradition zu den Heiligen Schriften
                                </h3>
                                <p className="mt-3">
                                    Das enorme Wissen des Ayurveda wurde ursprünglich von weisen Gelehrten aus dem alten Indien über Generationen hinweg mündlich weitergegeben. Später wurde es um das 2. Jahrtausend v. Chr. in Sanskrit niedergeschrieben – in den ältesten heiligen Schriften Indiens, den Veden. Diese Texte bilden nicht nur die Grundlage des Ayurveda, sondern auch die Ursprünge der Yoga-Lehren und -Praxis.
                                </p>
                            </div>

                            <div>
                                <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c] sm:text-3xl">
                                    Die drei wichtigsten medizinischen Hauptwerke
                                </h3>
                                <p className="mt-3">
                                    Die folgenden drei Heiligen Schriften, die zwischen 2500 und 1200 Jahren vor Christus kompiliert wurden, spielen in der Ayurveda-Medizin eine extrem wichtige Rolle.
                                </p>
                                <ul className="mt-4 space-y-2 border-l-2 border-[#F28600] pl-5 font-semibold text-[#24422f]">
                                    <li>Charaka Samhita</li>
                                    <li>Sushruta Samhita</li>
                                    <li>Ashthanga Hridaya Samhita</li>
                                </ul>
                                <p className="mt-4">
                                    Diese Bücher enthalten bemerkenswert detailliertes Wissen über den menschlichen Körper, Krankheitserreger, Hygiene und sogar fortgeschrittene chirurgische Techniken.
                                </p>
                            </div>

                            <div>
                                <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c] sm:text-3xl">
                                    Was bedeutet wahre „Gesundheit“?
                                </h3>
                                <p className="mt-3">
                                    Vor etwa 2500 Jahren definierte der indische Arzt Sushruta, der als einer der ersten Chirurgen der Welt gilt, den Zustand eines „gesunden Menschen“ im Ayurveda wie folgt.
                                </p>
                                <blockquote className="mt-5  pt-5 font-serif text-xl leading-relaxed text-[#1f4d3c] sm:text-2xl">
                                    „Ein Mensch ist wirklich gesund, wenn er in sich selbst gefestigt ist, ein Gleichgewicht zwischen Doshas (Lebensenergien), Agni (Verdauungsfeuer), Dhatus (Körpergeweben) und Malas (Ausscheidungen) besitzt und seine körperlichen Funktionen sowie Geist, Seele und Sinne in Zufriedenheit und Harmonie stehen.“
                                    <cite className="mt-4 block font-mulish text-sm not-italic text-gray-600 sm:text-base">
                                        —— Sushruta Samhita, Kapitel 15, Vers 38
                                    </cite>
                                </blockquote>
                            </div>
                        </div>
                    </div>

                    <div className="order-2 lg:sticky lg:top-28">
                        <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] bg-[#f3eee7] shadow-[0_24px_70px_rgba(16,38,26,0.14)]">
                            <img
    src="/images/ayurveda-massage-treatment.webp"
    alt="Ayurveda-Behandlung"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/55 via-transparent to-transparent" />
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default History;
